import Feedback from "./typeform";
import { useTranslation } from "react-i18next";

// TODO finish i18n setting
export default function Footer({ registered, setRegistered }) {
  const { t } = useTranslation();

  return (
    <div>
      <div className={"grid " + (registered ? "" : "hidden")}>
        <button
          type="submit"
          className="text-sm text-gray-500 font-bold rounded-sm hover:bg-gray-100"
          onClick={() => setRegistered(false)}
        >
          {t("description.footerReset")}
        </button>
      </div>
      <div className="flex justify-between text-sm text-gray-300 mt-4">
        <span>
          Inspired by{" "}
          <a
            href="https://waitbutwhy.com/2014/05/life-weeks.html"
            className="border-b-2 border-opacity-25 hover:border-gray-500 hover:text-gray-500"
          >
            Tim Urban
          </a>
        </span>
        <span>
          Build by &copy;{" "}
          <a
            href="https://www.cliveshd.com"
            className="border-b-2 border-opacity-25 hover:border-gray-500 hover:text-gray-500"
          >
            Clive
          </a>{" "}
        </span>
        <span>
          Improved by &nbsp;
          <span className="border-b-2 border-opacity-25 hover:border-gray-500 hover:text-gray-500">
            <Feedback />
          </span>
        </span>
      </div>
    </div>
  );
}
